import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

import styles from './styles.css'

momentDurationFormatSetup(Moment)

const StatusDot = ({ style, status }) => {
  let statusColor
  switch (status) {
    case 1:
      statusColor = 'rgba(219, 61, 59, 1)'
      break
    case 2:
      statusColor = 'rgba(237, 224, 109, 1)'
      break
    case 3:
      statusColor = 'rgba(27, 153, 104, 1)'
      break
    default:
      statusColor = 'rgba(117, 119, 128, 1)'
  }
  return <i style={{ color: statusColor, ...style }} className="fa fa-circle" />
}

class ListCard extends PureComponent {
  static propTypes = {
    toUserId: PropTypes.string.isRequired,
    invitationId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    noteStatus: PropTypes.number.isRequired,
    deleteCard: PropTypes.func.isRequired,
    sendNoteCard: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  sendNoteClick = () => {
    const { sendNoteCard, toUserId } = this.props
    sendNoteCard(toUserId)
  }

  deleteClick = () => {
    const { deleteCard, invitationId, name } = this.props
    deleteCard(invitationId, name)
  }

  renderNoteStatusIcon = () => {
    const { noteStatus } = this.props
    let iconName

    switch (noteStatus) {
      case 1:
        iconName = 'fa-envelope'
        break
      case 2:
        iconName = 'fa-envelope-open'
        break
      case 3:
        iconName = 'fa-envelope-open-o'
        break
      default:
        iconName = 'fa-pencil'
    }
    return <i onClick={this.sendNoteClick} className={classnames(`fa ${iconName}`, styles.icon)} />
  }

  render() {
    const { name, email, status } = this.props
    return (
      <div className={styles.cardContainer}>
        <div className={styles.statusIconContainer}>
          <StatusDot status={status} style={{ fontSize: 25 }} />
        </div>
        <div className={styles.nameEmailContainer}>
          <div style={{ fontSize: 18, color: 'white', marginBottom: 3, flex: 0.4 }}>{name}</div>
          <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', flex: 0.6 }}>{email}</div>
        </div>
        <div className={styles.iconContainer}>
          {this.renderNoteStatusIcon()}
          <i onClick={this.deleteClick} className={classnames('fa fa-trash', styles.icon)} />
        </div>
      </div>
    )
  }
}

export default ListCard



// WEBPACK FOOTER //
// ./src/views/collaborate/collaborator-panel/list-card/index.js